<template>
  <div
    class="operation-statement"
    :class="{ 'operation-statement-store': isStore }"
  >
    <HeaderBar />
    <div class="header">
      <h1 class="title">
        经营报表
        <span
          v-if="!isComponent"
          @click="handleOpenFilter"
          class="link"
          :class="{ 'store-link': isStore }"
        >
          筛选
        </span>
      </h1>
      <!--      <p class="time">数据更新于 2024 年 12 月 24 日 12:32</p>-->
    </div>
    <div class="total-bar">
      <span class="text">总计</span>
      <div class="right">
        <p class="num">{{ reportData.orderNum }}<span class="unit">笔</span></p>
        <p class="v-line"></p>
        <p class="num">
          ¥{{
            reportData.totalAmount ? NP.divide(reportData.totalAmount / 100) : 0
          }}
        </p>
      </div>
    </div>
    <div class="module-wrap">
      <div v-for="(item, index) in labelList" :key="index" class="module-box">
        <span :class="['dot', 'dot-' + item.key]"></span>
        <p class="label">{{ item.name }}</p>
        <div class="bottom">
          <p class="num">
            {{ reportData[`${item.key}OrderNum`] }}<span class="unit">笔</span>
          </p>
          <p class="v-line"></p>
          <p class="num">
            ¥{{
              reportData[`${item.key}Amount`]
                ? NP.divide(reportData[`${item.key}Amount`], 100)
                : 0
            }}
          </p>
        </div>
      </div>
    </div>
    <FilterPanelPopup
      v-model="filterPanelVisible"
      @confirm="handleConfirmPopup"
    >
      <OrderFilterPanel
        ref="orderFilterPanel"
        :isComponent="isComponent"
        :levelList="levelList"
        :authData="authData"
        :agentSetting="agentSetting"
      />
    </FilterPanelPopup>
  </div>
</template>

<script>
import HeaderBar from './components/HeaderBar'
import FilterPanelPopup from './components/FilterPanelPopup'
import OrderFilterPanel from './components/Order/OrderFilterPanel'
import { getOrderPerformanceSum } from '../../utils/http/modules/agent/order'
import { getOrderPerformanceSumByStore } from '@store/api/statistics.api'
import NP from 'number-precision'
import { ORDER_LIST, DELIVERY_TYPE } from './js/enum'
import { mapGetters } from 'vuex'
import muTypes from '@/store/mutation-types.js'
import { agentCommonInfoMixins } from './js/mixins'
import { getWeChatSignature } from '@/utils/wxconfig'
// 大健康 - 门店系统相关控制器与组件
import StoreController from '@/controllers/storeController/view/store/store.controller.js'

export default {
  name: 'OperationStatement',
  props: {
    isComponent: Boolean,
    storeId: {
      type: Number,
    },
  },
  mixins: [agentCommonInfoMixins],
  components: { OrderFilterPanel, FilterPanelPopup, HeaderBar },
  data() {
    return {
      NP,
      filterPanelVisible: false,
      reportData: {},
      agentSetting: {},
      authData: {},
      levelList: [],
    }
  },
  computed: {
    labelList() {
      return ORDER_LIST.filter(
        item =>
          item.name != '全部' &&
          item.deliveryType == DELIVERY_TYPE.COMMODITY_DISTRIBUTION
      )
    },
    ...mapGetters(['orderFilterParams']),
    // * 当前是否门店系统客户模块
    isStore() {
      return StoreController.isStore()
    },
  },
  created() {
    getWeChatSignature()
    this.handleDisplayLevelList(() => {
      this._getOrderPerformanceSum()
      this.$store.commit(
        muTypes.updateOrderFilterParams,
        this.orderFilterParams
      )
    })
  },
  beforeDestroy() {
    this.orderFilterParams.deliveryType = -1
    this.orderFilterParams.orderStatus = -999
    this.orderFilterParams.orderSegmentType = [
      200, 1227, 240, 1212, 1288, 1211, 1315,
    ]
    this.$store.commit(muTypes.updateOrderFilterParams, this.orderFilterParams)
  },
  methods: {
    handleOpenFilter() {
      if (this.$props.isComponent) {
        this.$emit('openFitler')
      } else {
        this.filterPanelVisible = true
      }
    },
    handleDisplayLevelList(callback) {
      this.fetchGetAgentAuth(data => {
        this.authData = data
        this.orderFilterParams.followLevel = this.authData.level
        this.fetchGetAgentSetting(dataObj => {
          this.agentSetting = dataObj
          // 处理等级列表展示
          this.handleLevelDisplay(
            levelList => {
              this.levelList = levelList
              if (this.authData.level == 1) {
                this.orderFilterParams.followType = 1
              }
              typeof callback === 'function' && callback()
            },
            this.authData,
            this.agentSetting
          )
        })
      })
    },
    getCommonParams() {
      let params = {
        ...this.orderFilterParams,
        storeId: this.storeId > 0 ? +this.storeId : undefined,
        isStoreProductStat: this.storeId > 0 ? 1 : 0,
      }
      return params
    },
    handleConfirmPopup() {
      this.$nextTick(() => {
        this.$store.commit(
          muTypes.updateOrderFilterParams,
          Object.assign(
            this.orderFilterParams,
            this.$refs.orderFilterPanel.formData
          )
        )
        this.filterPanelVisible = false
        this._getOrderPerformanceSum()
      })
    },
    async _getOrderPerformanceSum() {
      try {
        const $api = this.isStore
          ? getOrderPerformanceSumByStore
          : getOrderPerformanceSum
        const { dataObj } = await $api(this.getCommonParams())
        this.reportData = dataObj || {}
      } catch (e) {
        e && this.$toast(e)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.operation-statement {
  width: 100%;
  background: rgba(245, 247, 250, 0.44)
    url('../../assets/images/agent/lower-bg.png') no-repeat center top;
  background-size: 100% 340px;
  min-height: 100vh;
  padding: 0 10px 20px;
  box-sizing: border-box;
  &.operation-statement-store {
    background: var(--primary-background-linear-gradient);
    background-size: 100% 30%;
    background-repeat: no-repeat;
  }
}
.header {
  width: 100%;
  padding: 20px 12px 0;
  box-sizing: border-box;
  margin-bottom: 16px;
  .title {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFang SC, PingFang SC;
    font-weight: 550;
    font-size: 16px;
    color: #202124;
    line-height: 24px;
  }
  .time {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #60646b;
    line-height: 20px;
    margin-top: 2px;
  }
}
.link {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #006cff;
  line-height: 22px;
  &.store-link {
    color: #ff6a00;
  }
}
.total-bar {
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  .text {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #919499;
    line-height: 22px;
  }
  .right {
    display: flex;
    align-items: center;
    .v-line {
      width: 1px;
      height: 12px;
      background: #edeff2;
      margin: 0 12px;
    }
    .num {
      display: flex;
      align-items: flex-end;
      font-family: TG-TYPE-Bold;
      font-weight: bold;
      font-size: 18px;
      color: #202124;
      line-height: 24px;
      .unit {
        font-family: TG-TYPE-Bold;
        font-weight: 400;
        font-size: 12px;
        color: #60646b;
        line-height: 22px;
        margin-left: 4px;
      }
    }
  }
}
.module-wrap {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 8px;
  box-sizing: border-box;
  .module-box {
    padding: 16px 0 16px 16px;
    box-sizing: border-box;
    position: relative;
    height: 84px;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
    .dot {
      position: absolute;
      left: 0;
      top: 20px;
      width: 3px;
      height: 12px;
      background: #006cff;
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
      &-noPay {
        background: #ffa800;
      }
      &-noShipments {
        background: #ff4444;
      }
      &-shipped {
        background: #00b849;
      }
      &-finish {
        background: #006cff;
      }
      &-refund {
        background: #b8babf;
      }
      &-cancel {
        background: #b8babf;
      }
    }
    .label {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #919499;
      line-height: 20px;
      margin-bottom: 5px;
    }
    .bottom {
      display: flex;
      align-items: center;
      .v-line {
        width: 1px;
        height: 12px;
        background: #edeff2;
        margin: 0 12px;
      }
      .num {
        display: flex;
        align-items: flex-end;
        font-family: TG-TYPE-Bold;
        font-weight: bold;
        font-size: 18px;
        color: #202124;
        line-height: 24px;
        &:last-of-type {
          .unit {
            margin-right: 4px;
          }
        }
        .unit {
          font-family: TG-TYPE-Bold;
          font-weight: 400;
          font-size: 12px;
          color: #60646b;
          line-height: 22px;
          margin-left: 4px;
        }
      }
    }
  }
}
</style>
